import { useEffect, useRef } from "react";

function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value; // Assign the value of ref to the argument
  }, [value]);
  return ref.current; // Return the current ref value.
}
export default usePrevious;
